import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class BusinessSettingsModel {
    static fromDTO(dto) {
        var _dto_templateVariables;
        return new BusinessSettingsModel(dto.legalTermsDocumentId, dto.disablePlaidLink, dto.netTerms, dto.billingDayOfMonth, dto.billingDayOfWeek, dto.feeControls, dto.amendmentsApprovalMethod, dto.invoicesApprovalMethod, dto.billUpfront, dto.automaticServicesPausedByDefault, dto.prorateFirstInvoice, dto.requestAccountantAccess, dto.introductoryMessages, dto.startBillingOn, dto.introVideo, dto.invoiceLineItems, dto.expirationDate, dto.invoicePrefix, (_dto_templateVariables = dto.templateVariables) !== null && _dto_templateVariables !== void 0 ? _dto_templateVariables : []);
    }
    constructor(legalTermsDocumentId, disablePlaidLink, netTerms, billingDayOfMonth, billingDayOfWeek, feeControls, amendmentsApprovalMethod, invoicesApprovalMethod, billUpfront, automaticServicesPausedByDefault, prorateFirstInvoice, requestAccountantAccess, introductoryMessages, startBillingOn, introVideo, invoiceLineItems, expirationDate, invoicePrefix, templateVariables){
        _define_property(this, "legalTermsDocumentId", void 0);
        _define_property(this, "disablePlaidLink", void 0);
        _define_property(this, "netTerms", void 0);
        _define_property(this, "billingDayOfMonth", void 0);
        _define_property(this, "billingDayOfWeek", void 0);
        _define_property(this, "feeControls", void 0);
        _define_property(this, "amendmentsApprovalMethod", void 0);
        _define_property(this, "invoicesApprovalMethod", void 0);
        _define_property(this, "billUpfront", void 0);
        _define_property(this, "automaticServicesPausedByDefault", void 0);
        _define_property(this, "prorateFirstInvoice", void 0);
        _define_property(this, "requestAccountantAccess", void 0);
        _define_property(this, "introductoryMessages", void 0);
        _define_property(this, "startBillingOn", void 0);
        _define_property(this, "introVideo", void 0);
        _define_property(this, "invoiceLineItems", void 0);
        _define_property(this, "expirationDate", void 0);
        _define_property(this, "invoicePrefix", void 0);
        _define_property(this, "templateVariables", void 0);
        this.legalTermsDocumentId = legalTermsDocumentId;
        this.disablePlaidLink = disablePlaidLink;
        this.netTerms = netTerms;
        this.billingDayOfMonth = billingDayOfMonth;
        this.billingDayOfWeek = billingDayOfWeek;
        this.feeControls = feeControls;
        this.amendmentsApprovalMethod = amendmentsApprovalMethod;
        this.invoicesApprovalMethod = invoicesApprovalMethod;
        this.billUpfront = billUpfront;
        this.automaticServicesPausedByDefault = automaticServicesPausedByDefault;
        this.prorateFirstInvoice = prorateFirstInvoice;
        this.requestAccountantAccess = requestAccountantAccess;
        this.introductoryMessages = introductoryMessages;
        this.startBillingOn = startBillingOn;
        this.introVideo = introVideo;
        this.invoiceLineItems = invoiceLineItems;
        this.expirationDate = expirationDate;
        this.invoicePrefix = invoicePrefix;
        this.templateVariables = templateVariables;
    }
}
